import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import * as actions from '../../../../state';
import { deleteBoard } from '../../../../events';

import { ConfirmationAction } from '../../../dialogs';

const messages = defineMessages({
  CONFIRM_DELETE_MSG: {
    id: 'CONFIRM_DELETE_MSG',
    defaultMessage: 'Delete this board?',
  },
  CONFIRM_DELETE_BODY: {
    id: 'CONFIRM_DELETE_BODY',
    defaultMessage: 'This action cannot be undone. Are you sure you want to delete this board?',
  },
  DELETE_TOOLTIP: {
    id: 'DELETE_TOOLTIP',
    defaultMessage: 'Delete board',
  },
  DELETE: {
    id: 'DELETE',
    defaultMessage: 'Delete',
  },
  DELETE_FAILED: {
    id: 'DELETE_FAILED',
    defaultMessage: 'Could not successfully delete this board.',
  },
});

function DeleteBoardBtn({ intl }) {
  const dispatch = useDispatch();

  const board = useSelector(actions.readStateBoard);

  const deleteAction = () => {
    dispatch(actions.isLoading(true));
    dispatch(deleteBoard(board, intl, messages));
  };

  return (
    <ConfirmationAction
      onConfirm={deleteAction}
      tooltipMsg={<FormattedMessage {...messages.DELETE_TOOLTIP} />}
      confirmMsg={<FormattedMessage {...messages.CONFIRM_DELETE_MSG} />}
      confirmBody={<FormattedMessage {...messages.CONFIRM_DELETE_BODY} />}
      confirmActionMsg={<FormattedMessage {...messages.DELETE} />}
    >
      <IconButton>
        <DeleteIcon />
      </IconButton>
    </ConfirmationAction>
  );
}

export default injectIntl(DeleteBoardBtn);
